import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchService } from '@nucleus/ui-base';
import { NucleusMailFilter } from '@nucleus/mail-report-ui';
import { ServiceHandler } from '@nucleus/ui-base';
import { PageResult } from '@nucleus/ui-base';
import { FilterRequest } from '../filter-request';
import { Page, QuerySortDirection } from '@nucleus/ui-base';
import { EmailRequest as Mail } from "@nucleus/mail-report-ui";
import { EmailContent as MailContent } from "@nucleus/mail-report-ui";
import { EmailStepResult as MailStepResult } from "@nucleus/mail-report-ui";
import {
  MailControllerService,
  PaginatedFilterRequestMailFilter,
} from '@nucleus/mail-report-ui';
import { RequestHandler } from '../request-handler';


@Injectable({
  providedIn: 'root'
})
export class MailService implements SearchService<Mail, NucleusMailFilter> {

  constructor(
    private api: MailControllerService,
    private requestHandler: RequestHandler,
  ) { }

  getMailTemplates(handler: ServiceHandler<string[]>): void {
    this.requestHandler.handleRequest(this.api.getTemplates() as unknown as Observable<string[]>, handler, false);
  }

  search(handler: ServiceHandler<Mail[]>): void {
    this.requestHandler.handleRequest(this.api.findAll() as unknown as Observable<Mail[]>, handler, false);
  }


  searchPaginated(handler: ServiceHandler<PageResult<Mail>>, pageSize: number, pageNumber: number, softField: string, sortDirection: QuerySortDirection) {
    let request = new FilterRequest<NucleusMailFilter>(new NucleusMailFilter());
    request.page.pageSize = pageSize;
    request.page.pageNumber = pageNumber;
    request.page.sortDirection = sortDirection;
    request.page.sortField = softField;
    this.filter(handler, request.filter, request.page);
  }

  filterPaginated(handler: ServiceHandler<PageResult<Mail>>, pageSize: number, pageNumber: number, softField: string, sortDirection: QuerySortDirection, filter: NucleusMailFilter): void {
    let request = new FilterRequest<NucleusMailFilter>(filter);
    request.page.pageSize = pageSize;
    request.page.pageNumber = pageNumber;
    request.page.sortDirection = sortDirection;
    request.page.sortField = softField;
    this.filter(handler, request.filter, request.page);
  }

  filter(handler: ServiceHandler<PageResult<Mail>>, filter: NucleusMailFilter, page?: Page, _clientId?: string): void {
    const request = new FilterRequest<NucleusMailFilter>(filter);
    if (page) { request.page = page; }
    this.requestHandler.handleRequest(
      this.api.filter(this.toApiFilterRequest(request)) as unknown as Observable<PageResult<Mail>>,
      handler,
      false,
    );
  }

  private toApiFilterRequest(request: FilterRequest<NucleusMailFilter>): PaginatedFilterRequestMailFilter {
    return {
      page: {
        pageSize: request.page?.pageSize,
        pageNumber: request.page?.pageNumber,
        sortField: request.page?.sortField,
        sortDirection: request.page?.sortDirection as unknown as string,
      },
      filter: { ...(request.filter as any) },
    };
  }

  getMailContent(emailRequestId: string, handler: ServiceHandler<MailContent>): void {
    this.requestHandler.handleRequest(this.api.findContent(emailRequestId) as unknown as Observable<MailContent>, handler, false);
  }

  getMailSteps(emailRequestId: string, handler: ServiceHandler<MailStepResult[]>): void {
    this.requestHandler.handleRequest(this.api.findSteps(emailRequestId) as unknown as Observable<MailStepResult[]>, handler, false);
  }

  getPDFReport(handler: ServiceHandler<Blob>, request: FilterRequest<NucleusMailFilter>) {
    this.requestHandler.handleRequest(this.api.createPdfReport(this.toApiFilterRequest(request)), handler, true);
  }

  getXLSReport(handler: ServiceHandler<Blob>, request: FilterRequest<NucleusMailFilter>) {
    this.requestHandler.handleRequest(this.api.createExcelReport(this.toApiFilterRequest(request)), handler, true);
  }

  getCSVReport(handler: ServiceHandler<Blob>, request: FilterRequest<NucleusMailFilter>) {
    this.requestHandler.handleRequest(this.api.createCSVReport(this.toApiFilterRequest(request)), handler, true);
  }

  resendEmail(handler: ServiceHandler<void>, emailRequestId: string): void {
    this.requestHandler.handleRequest(this.api.resend(emailRequestId), handler, false);
  }
}
